import { modelsCompFn } from '@/lib/filter/base-frontend-filter/scope';

export const userFn = ({ propertyValues, scope }) => {
  const models = propertyValues.find((pv) => pv.property.uid === scope.property.uid)?.users;
  const neededModels = scope.users;
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};

export const directUserFn = ({ entity, scope }) => {
  const models = entity[scope.directProperty.edgeName];
  const neededModels = scope.users;
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};

export const staticUserFn = ({ entity, scope }) => {
  const models = [entity];
  const neededModels = scope.staticUsers;
  return modelsCompFn({ models, neededModels });
};
